/* GG add-to-cart behaviour — MOBILE ONLY.
   On phones (<=767px) the mini-cart drawer was slow (~2s) and froze the screen
   with no feedback, so shoppers tapped again and got 2 of everything. On mobile
   we send them to the /cart page after adding — clear result, and a double is
   impossible because the page navigates away.

   IMPORTANT: some products add MORE THAN ONE line item per tap (e.g. the phone
   plus a Webkul extended-warranty item, or a bundled accessory). The warranty is
   a SECOND /cart/add that fires just after the phone. So we must NOT navigate the
   moment the first add finishes, or the warranty gets cut off. Instead we watch
   all /cart/add requests and only leave once none are in flight AND a short quiet
   period has passed (with a hard cap as a safety net). This guarantees add-ons
   are always in the cart before we leave.

   DESKTOP: this script does NOTHING that affects behaviour — the native theme
   flow (mini-cart drawer) is untouched. No effect on the quantity picker or the
   "Buy with Shop" button. */
(function(){
var S='.product-form__add-button,.product-item__action-button',d=document;
var MOBILE='(max-width: 767px)',QUIET=1500,HARDCAP=9000;
function isMobile(){return !!(window.matchMedia&&window.matchMedia(MOBILE).matches);}
function cartUrl(){return (window.routes&&window.routes.cartUrl)||'/cart';}
function isAdd(u){u=''+(u||'');return u.indexOf('/cart/add')>-1;}
var armed=false,navGuard=false,pending=0,quietTimer=null;
function goCart(){if(navGuard)return;navGuard=true;try{window.location.assign(cartUrl());}catch(e){window.location.href=cartUrl();}}
function maybeLeave(){
if(!armed)return;
if(quietTimer)clearTimeout(quietTimer);
quietTimer=setTimeout(function(){ if(pending<=0){goCart();} else {maybeLeave();} },QUIET);
}
function addStart(){pending++;}
function addEnd(){pending=(pending>0?pending-1:0);if(armed)maybeLeave();}
// Watch add-to-cart requests (theme + warranty/bundle apps) via fetch and XHR.
var of=window.fetch;
if(of){window.fetch=function(){var u=arguments[0];u=(u&&u.url)||u;if(isAdd(u)){addStart();var p;try{p=of.apply(this,arguments);}catch(e){addEnd();throw e;}Promise.resolve(p).then(addEnd,addEnd);return p;}return of.apply(this,arguments);};}
var oo=XMLHttpRequest.prototype.open,os=XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.open=function(m,u){this.__ggAdd=isAdd(u);return oo.apply(this,arguments);};
XMLHttpRequest.prototype.send=function(){if(this.__ggAdd){addStart();this.addEventListener('loadend',addEnd);}return os.apply(this,arguments);};
// spinner style (only ever applied on mobile)
var css='.product-form__add-button.gg-adding,.product-item__action-button.gg-adding{position:relative;pointer-events:none;opacity:.75}.product-form__add-button.gg-adding::after,.product-item__action-button.gg-adding::after{content:"";position:absolute;top:50%;left:50%;width:16px;height:16px;margin:-8px 0 0 -8px;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:gg-spin .6s linear infinite}@keyframes gg-spin{to{transform:rotate(360deg)}}';
var st=d.createElement('style');st.appendChild(d.createTextNode(css));(d.head||d.documentElement).appendChild(st);
d.addEventListener('click',function(e){
if(!isMobile())return;                       // DESKTOP: leave everything to the theme
var b=e.target&&e.target.closest&&e.target.closest(S);if(!b)return;
if(armed){e.preventDefault();e.stopImmediatePropagation();return;}  // block repeat taps (mobile only)
armed=true;b.classList.add('gg-adding');
setTimeout(goCart,HARDCAP);                   // safety net: never wait forever
setTimeout(maybeLeave,600);                   // in case no add request is detected
},true);
})();
